import React from 'react';
import { StoreScene } from './StoreScene';

export function GenerateLayer() {
  return (
    <section id="generate" className="scroll-mt-24">
      <div className="flex items-center gap-4 mb-5">
        <span className="font-mono text-sm text-white border border-white/20 rounded-lg px-2.5 py-1.5 bg-white/5 shrink-0">02</span>
        <div>
          <h3 className="text-base font-bold text-white">Generate</h3>
          <p className="text-sm text-white/40">A world model reconstructs your space — live shopper simulation</p>
        </div>
      </div>

      <StoreScene />

      <div className="mt-3 flex flex-wrap gap-x-5 gap-y-2 font-mono text-[10px] tracking-widest uppercase text-white/50">
        <span><i className="inline-block w-2 h-2 rounded-full bg-amber-500 mr-1.5" />Family shop ×12</span>
        <span><i className="inline-block w-2 h-2 rounded-full bg-blue-400 mr-1.5" />Top-up run ×18</span>
        <span><i className="inline-block w-2 h-2 rounded-full bg-emerald-500 mr-1.5" />Health trip ×7</span>
        <span><i className="inline-block w-2 h-2 rounded-full bg-violet-400 mr-1.5" />Frozen restock ×5</span>
        <span><i className="inline-block w-2 h-2 rounded-full bg-red-500 mr-1.5" />Dwell anomaly ×1</span>
        <span><i className="inline-block w-2 h-2 rounded-full bg-emerald-500/80 mr-1.5" />Entrance</span>
      </div>

      <div className="mt-3 text-center border border-white/40 rounded-full bg-white/[0.07] py-2 font-mono text-[11px] tracking-[0.2em] uppercase font-semibold text-white">
        Generated spatial view · WebGL replica · shoppers live
      </div>
    </section>
  );
}
